module.exports = __webpack_public_path__ + "img/session-bg-2.ded91424.png";